module.exports = __webpack_public_path__ + "img/k-bank46x46.6ab3fa23.jpg";